/*@ngInject*/
const WizardContextModel = function ($rootScope, submissionConstant) {
    var contextId = 0,
        contextType = null,
        contextLabel = '',
        contextUri = '',
        hierarchicalContextList = [];

    this.setContextId = function (contextId) {
        this.contextId = contextId;
    };

    this.getContextId = function () {
        return this.contextId;
    };

    this.setContextType = function (contextType) {
        this.contextType = contextType;
    };

    this.getContextType = function () {
        return this.contextType;
    };

    this.setContextLabel = function (contextLabel) {
        this.contextLabel = contextLabel;
    };

    this.getContextLabel = function () {
        return this.contextLabel;
    };

    this.setContextUri = function (contextUri) {
        this.contextUri = contextUri;
    };

    this.getContextUri = function () {
        return this.contextUri;
    };

    this.setHierarchicalContextList = function (hierarchicalContextList) {
        this.hierarchicalContextList = hierarchicalContextList;
    };

    this.getHierarchicalContextList = function () {
        return this.hierarchicalContextList;
    };

    this.setContext = function (context) {
        this.contextId = context.contextId;
        this.contextType = context.contextType;
        this.contextLabel = context.contextLabel;
        this.contextUri = context.contextUri;
        this.hierarchicalContextList = context.hierarchicalContextList;
    };

    this.getContext = function () {
        return {
            contextId: this.contextId,
            contextType: this.contextType,
            contextLabel: this.contextLabel,
            contextUri: this.contextUri,
            hierarchicalContextList: this.hierarchicalContextList
        };
    };

    this.resetContext = function () {
        contextId = 0;
        contextType = null;
        contextLabel = '';
        contextUri = '';
        hierarchicalContextList = [];
    };
};

angular.module('gw-um-submission')
    .service('wizardContextModel', WizardContextModel);
